import { observable } from "@legendapp/state";

/** Space/topic from Topics "Chat" or aligned with URL chat navigation — used when resolving document links on /chat. */
export type ActiveChatContext = {
  spaceId: string | null;
  topicId: string | null;
};

export const activeChatContext$ = observable<ActiveChatContext>({
  spaceId: null,
  topicId: null,
});

export function setActiveChatContext(next: ActiveChatContext): void {
  activeChatContext$.set(next);
}

export function clearActiveChatContext(): void {
  activeChatContext$.set({ spaceId: null, topicId: null });
}
